import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { sessionApiStore, sessionStore } from "@/hooks";
import {
  PanelCard,
  FlexBox,
  Typography,
  TextButton,
} from "@/components/common";


/**
 * Displays an action to log out of the app.
 */
const __default__ = {
  name: "LogOut",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const email = computed(() => sessionStore.user?.email || "");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), { title: "My Account" }, {
    default: _withCtx(() => [
      _createVNode(_unref(FlexBox), {
        justify: "between",
        align: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Typography), { value: email.value }, null, 8, ["value"]),
          _createVNode(_unref(TextButton), {
            text: "",
            label: "Log Out",
            icon: "logout",
            "data-cy": "button-account-logout",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(sessionApiStore).handleLogout(true)))
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})